import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from './Card.module.pcss';

const cx = classNames.bind(styles);

interface ShimmerPropType {
  variant: string;
  id: string;
}

const Shimmer = (props: ShimmerPropType): ReactElement => {
  const { variant, id } = props;
  const msiteStripe = cx('card-shm__stripe');
  const desktopStripe = cx('desktop-card-shm__stripe');
  return variant === 'mobile' ? (
    <div className={cx('card-shm')} key={id}>
      <div className={`ldr ${cx('card-shm__round')}`} />
      <div className={cx('card-shm__stripe-container')}>
        <div className={cx('card-shm__stripe-content')}>
          <div className={`ldr ${msiteStripe} ${cx('card-shm__stripe-title')}`} />
          <div className={`ldr ${msiteStripe} ${cx('card-shm__stripe-subtitle')}`} />
          <div className={`ldr ${msiteStripe} ${cx('card-shm__stripe-price')}`} />
        </div>
        <div className={`ldr ${msiteStripe} ${cx('card-shm__stripe-btn')}`} />
      </div>
    </div>
  ) : (
    <div className={cx('desktop-card-shm')} key={id}>
      <div className={`ldr ${cx('desktop-card-shm__round')}`} />
      <div className={cx('desktop-card-shm__stripe-container')}>
        <div className={cx('desktop-card-shm__stripe-content')}>
          <div className={`ldr ${desktopStripe} ${cx('desktop-card-shm__stripe-title')}`} />
          <div className={`ldr ${desktopStripe} ${cx('desktop-card-shm__stripe-subtitle1')}`} />
          <div className={`ldr ${desktopStripe} ${cx('desktop-card-shm__stripe-subtitle2')}`} />
        </div>
        <div className={cx('desktop-card-shm__price-content')}>
          <div className={`ldr ${desktopStripe} ${cx('desktop-card-shm__stripe-btn')}`} />
          <div className={`ldr ${desktopStripe} ${cx('desktop-card-shm__stripe-btn')}`} />
          <div className={`ldr ${desktopStripe} ${cx('desktop-card-shm__stripe-label')}`} />
        </div>
      </div>
    </div>
  );
};

export default Shimmer;
